import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { AuthorizationType } from "../../../commonTypes/invoiceGenerationTypes";
import {
  ConsignorDetailsType,
  DetailsType,
} from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import { HidePassword, ViewPassword } from "../../Icon";

type AppProps = {
  data: AuthorizationType;
  handleChange: (data: React.ChangeEvent<HTMLInputElement>) => void;
  gstData: any;
  isOpen: boolean;
  toggleAuthorization: () => void;
  handleSubmit: () => void;
  type: string;
};

const AuthorizationModal = ({
  data,
  handleChange,
  gstData,
  isOpen,
  toggleAuthorization,
  handleSubmit,
  type,
}: AppProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Modal
      isOpen={isOpen}
      backdrop="static"
      centered
      toggle={toggleAuthorization}
      size={"lg"}
    >
      <ModalHeader toggle={toggleAuthorization}>
        {type === "eInvoice"
          ? "E-Invoice Authentication"
          : "E-Way Bill Authentication"}
      </ModalHeader>

      <ModalBody>
        <div style={{ width: "100%", paddingTop: "20px" }}>
          <div
            style={{
              backgroundColor: "#fef2ed",
              color: "#ba4916",
              border: "1px solid #ba4916",
              // display: "flex",
              // alignItems: "start",
              padding: "10px",
            }}
          >
            <div>
              It is mandatory to enable API access from the
              {type === "EwayBill"
                ? " E-Waybill Portal"
                : " E-Invoice Portal"}{" "}
              . Follow the steps by clicking on the link, if not done already.
              Click Here{" "}
              <Button
                color="link"
                className="p-0"
                style={{ fontSize: "12px" }}
                onClick={() => {
                  if (type === "EwayBill")
                    window.open("/eway-bill-steps", "_blank");
                  else window.open("/einvoice-steps", "_blank");
                }}
              >
                {type === "EwayBill"
                  ? "View E-Waybill Steps"
                  : "View E-Invoice Steps"}
              </Button>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-3">
            <label>GSP Username</label>
            <input
              type="text"
              className={`form-control`}
              name="userName"
              value={data.userName}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange(e)
              }
            />
          </div>

          <div className="password-position">
            <label htmlFor="password" className={data.password ? "active" : ""}>
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              className={`form-control`}
              name="password"
              value={data.password}
              autoComplete="password"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange(e)
              }
            />

            <div className="eye-icon" onClick={toggleShowPassword}>
              {showPassword ? <ViewPassword /> : <HidePassword />}
            </div>
          </div>
        </div>

        <div className="mt-3">
          <button
            className="btn btn-primary"
            disabled={!data?.userName?.trim() || !data?.password?.trim()}
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>

        <div className="mt-3">
          <h6>GST Details</h6>

          <div className="row">
            <div className="col-md-3">
              <label htmlFor="email">GST Number</label>
              <p className="mt-1">
                {type === "eInvoice"
                  ? gstData?.gstin
                  : gstData?.gstin_of_consignor}
              </p>
            </div>

            <div className="col-md-3">
              <label htmlFor="email">Legal Name</label>
              <p className="mt-1">
                {type === "eInvoice"
                  ? gstData?.legal_name
                  : gstData?.legal_name_of_consignor}
              </p>
            </div>

            {type === "eInvoice" ? (
              <div className="col-md-3">
                <label htmlFor="email">Trade Name</label>
                <p className="mt-1">{gstData?.trade_name}</p>
              </div>
            ) : null}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AuthorizationModal;
